<template>
  <div class="cc-main">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'cc-main',

  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.cc-main {
  flex: 1;
  display: block;
  flex-basis: 1;
  overflow: auto;
  margin-bottom: 1px;
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index:1;
}
</style>
